import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import { cn } from '@app/shared/utils/common';

const Switch = React.forwardRef<
  React.ComponentRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'inline-flex h-[31px] w-[53px] shrink-0 cursor-pointer items-center rounded-full shadow-[0_4px_4px_#0a78e65e_inset] transition-colors disabled:cursor-not-allowed data-[state=checked]:bg-tertiary-accent data-[state=unchecked]:bg-tertiary',
      'duration-400',
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block h-[25px] w-[25px] rounded-full transition-transform data-[state=checked]:translate-x-[25px] data-[state=unchecked]:translate-x-[3px] data-[state=checked]:bg-tertiary data-[state=unchecked]:bg-tertiary-accent',
        'duration-400'
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
